import { AdminLayerGroup, Danger, Layer, Radios, User } from "@app/types";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [] as User[],
  usersLoaded: false,

  layers: [] as Layer[],
  layersLoaded: false,

  groups: [] as AdminLayerGroup[],
  groupsLoaded: false,

  dangers: [] as Danger[],
  dangersLoaded: false,

  radios: [] as Radios[],
  radiosLoaded: false,
}

const slice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    //users
    setUsers: (state, action: PayloadAction<User[]>) => {
      state.users = action.payload
      state.usersLoaded = true
    },
    addUser: (state, action: PayloadAction<User>) => {
      state.users.push(action.payload)
    },
    updateUser: (state, action: PayloadAction<User>) => {
      state.users = state.users.map(layer => {
        if (layer.id === action.payload.id) {
          return action.payload
        }
        return layer
      })
    },
    removeUsers: (state, action: PayloadAction<number[]>) => {
      state.users = state.users.filter(({id}) => action.payload.indexOf(id) === -1)
    },

    //layers
    setLayers: (state, action: PayloadAction<Layer[]>) => {
      state.layers = action.payload
      state.layersLoaded = true
    },
    addLayer: (state, action: PayloadAction<Layer>) => {
      state.layers.push(action.payload)
    },
    updateLayer: (state, action: PayloadAction<Layer>) => {
      state.layers = state.layers.map(layer => {
        if (layer.id === action.payload.id) {
          return action.payload
        }
        return layer
      })
    },
    removeLayers: (state, action: PayloadAction<number[]>) => {
      state.layers = state.layers.filter(({id}) => action.payload.indexOf(id) === -1)
    },

    //layers groups
    setGroups: (state, action: PayloadAction<AdminLayerGroup[]>) => {
      state.groups = action.payload
      state.groupsLoaded = true
    },
    addGroup: (state, action: PayloadAction<AdminLayerGroup>) => {
      state.groups.push(action.payload)
    },
    updateGroup: (state, action: PayloadAction<AdminLayerGroup>) => {
      state.groups = state.groups.map(group => {
        if (group.id === action.payload.id) {
          return action.payload
        }
        return group
      })
    },
    removeGroups: (state, action: PayloadAction<number[]>) => {
      state.groups = state.groups.filter(({id}) => action.payload.indexOf(id) === -1)
    },

    //dangers
    setDangers: (state, action: PayloadAction<Danger[]>) => {
      state.dangers = action.payload
      state.dangersLoaded = true
    },
    addDanger: (state, action: PayloadAction<Danger>) => {
      state.dangers.push(action.payload)
    },
    updateDanger: (state, action: PayloadAction<Danger>) => {
      state.dangers = state.dangers.map(layer => {
        if (layer.id === action.payload.id) {
          return action.payload
        }
        return layer
      })
    },
    removeDangers: (state, action: PayloadAction<number[]>) => {
      state.dangers = state.dangers.filter(({id}) => action.payload.indexOf(id) === -1)
    },

    //radios
    setRadios: (state, action: PayloadAction<Radios[]>) => {
      state.radios = action.payload
      state.radiosLoaded = true
    },
    addRadio: (state, action: PayloadAction<Radios>) => {
      state.radios.push(action.payload)
    },
    updateRadio: (state, action: PayloadAction<Radios>) => {
      state.radios = state.radios.map(item => {
        if (item.id === action.payload.id) {
          return action.payload
        }
        return item
      })
    },
    removeRadios: (state, action: PayloadAction<number[]>) => {
      state.radios = state.radios.filter(({id}) => action.payload.indexOf(id) === -1)
    },
  }
})


export const {
  setUsers, addUser, updateUser, removeUsers,
  setLayers, addLayer, updateLayer, removeLayers,
  setGroups, addGroup, updateGroup, removeGroups,
  setDangers, addDanger, updateDanger, removeDangers,
  setRadios, addRadio, updateRadio, removeRadios,
} = slice.actions

export default slice.reducer